import {
  AfterViewInit,
  Component,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import PolarLogin from './PolarLogin';

@Component({
  selector: 'app-polar-login',
  template: `<div [id]="rootId" style="transition: 0.6s"></div>`,
  encapsulation: ViewEncapsulation.None
})
export class PolarLoginWrapper implements OnChanges, OnDestroy, AfterViewInit {
  public rootId = 'polar-login-root';

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit(): void {
    this.render();
  }

  ngOnDestroy(): void {
    ReactDOM.unmountComponentAtNode(document.getElementById(this.rootId) as Element);
  }

  private render(): void {
    ReactDOM.render(
      React.createElement(PolarLogin),
      document.getElementById(this.rootId)
    );
  }
}
